<script lang="ts">
    import {Beneficiary} from "../../models/Beneficiary";
    import BeneficiaryInfoEdit from "./BeneficiaryInfoEdit.svelte";
    import {getGovIdDisplayed} from "../../services/ApplicationDataService";
     import {parseBeneficiaryRelationshipType, updateBeneficiary} from "../../services/ApplicationDataService";
     import {validatePhone, validateDate} from "../../services/Utilities";
    import {createEventDispatcher} from "svelte";
    import {Address} from "../../models/Address";
    const dispatch = createEventDispatcher();
     export let viewBeneficiary: Beneficiary;
    export let isPrimary: boolean = true;
    let beneficiary = {...viewBeneficiary};
    let editMode: Boolean = false;
    let beneForm;
    let clonedAddress: Address;

    let buttonText = 'Edit my information';

    $: if (viewBeneficiary) {
        beneficiary = {...viewBeneficiary};
        beneficiary.personDOB = beneficiary.personDOB || '';
        beneficiary.trustDate = beneficiary.trustDate || '';
        beneficiary.phoneNumber = beneficiary.phoneNumber || '';
        clonedAddress = beneficiary.address || new Address();
    }
       const toggleBeneficiaryDetailsEditMode =  () => {
           if (editMode) {
               if (!beneForm.checkValidity()) {
                   return false;
               }
               if (!validatePhone(beneficiary.phoneNumber)) {
                   return false;
               }
               if (beneficiary.beneficiaryType == 1 && !validateDate(beneficiary.personDOB)) {
                   return false;
               }

               if (beneficiary.beneficiaryType == 3 && !validateDate(beneficiary.trustDate)) {
                   return false;
               }

               beneficiary.address = clonedAddress;
             updateBeneficiary(beneficiary);
              beneficiary = {...beneficiary};
              clonedAddress = {...clonedAddress};
               buttonText = 'Edit my information';
           } else {
              buttonText = 'Close and save my information'
           }
            editMode = !editMode
           dispatch("modeOnChange", editMode);
       }
</script>
<form bind:this={beneForm}>
<div class="beneficiary-info info-section">

        <div class="edit-section">
<!--            <h3>Primary Beneficiary</h3>-->
 <h2> Beneficiary Info</h2>

        </div>
        <hr/>
    {#if !editMode}
        {#if beneficiary && beneficiary.beneficiaryType && [1, 2, 3, 4, 5].includes(beneficiary.beneficiaryType)}
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">{isPrimary == true ? 'Primary': 'Contingent'} Beneficiary Type:</div>
                    <div class="bold-text">{beneficiary.beneficiaryTypeDescription || ''}</div>
                </div>
            </div>
            {#if beneficiary.beneficiaryType == 1}
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Relationship:</div>
                        <div class="bold-text">{parseBeneficiaryRelationshipType(Number(beneficiary.beneficiaryRelationship))} </div>
                    </div>
                </div>
                <div class="text-row">
                   <div class="text-group">
                       <div class="content-text-label">Beneficiary Name:</div>
                                              <div class="bold-text">{beneficiary.personFirst || ''} {beneficiary.personLast || ''} {beneficiary.personSuffix || ''}</div>
                   </div>
                </div>

                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Beneficiary Birth Date:</div>
                        <div class="bold-text">{beneficiary.personDOB || ''}</div>
                    </div>
                </div>
            {:else if beneficiary.beneficiaryType == 2}
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Company Name:</div>
                        <div class="bold-text">{beneficiary.companyName || ''} </div>
                    </div>
                </div>
            {:else if beneficiary.beneficiaryType == 3}
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Trust Name:</div>
                        <div class="bold-text">{beneficiary.trustName || ''}</div>
                    </div>
                </div>
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Trust Date:</div>
                        <div class="bold-text">{beneficiary.trustDate || ''}</div>
                    </div>
                </div>
                  <div class="text-row">
                                    <div class="text-group">
                                        <div class="content-text-label">SSN / TaxID:</div>
                                        <div class="bold-text">{getGovIdDisplayed(beneficiary.govId)}</div>
                                    </div>
                                </div>
            {/if}

            {#if  [1, 2, 3].includes(beneficiary.beneficiaryType)}
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Beneficiary Address:</div>
                        {#if clonedAddress}
                            <div class="bold-text">{clonedAddress.address1 || ''}
                             {#if clonedAddress.address2}
                              <br/> {clonedAddress.address2}
                             {/if}
                             <br/>{clonedAddress.city ? clonedAddress.city + ', ' : ''} {clonedAddress.state || ''} {clonedAddress.zipCode || ''}</div>
                        {/if}
                    </div>
                </div>
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Phone Number:</div>
                        <div class="bold-text">{beneficiary.phoneNumber || ''}</div>
                    </div>
                </div>
            {/if}
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Percentage:</div>
                    <div class="bold-text">{beneficiary.percentage || ''}%</div>
                </div>
            </div>

        {/if}
    {/if}

{#if editMode}
    <BeneficiaryInfoEdit beneficiary={beneficiary} beneficiaryAddress={clonedAddress} />
    {/if}

     <div>
       {#if beneficiary && beneficiary.beneficiaryType && [1, 2, 3].includes(beneficiary.beneficiaryType)}
                    <button on:click={toggleBeneficiaryDetailsEditMode}
                     class="card-link buttonWithoutBorder"
                     type="button">{buttonText}</button>
                    {:else}
                    <br />
                {/if}
    </div>
</div>

</form>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;
</style>
